import { Link } from "react-router-dom";
import { FiCheck, FiX } from "react-icons/fi";

import "./pricing.css";

const PricingPlans = () => {
  return (
    <section className="pricing-section" id="pricing"data-aos="fade-up"> 
      <h2 className="pricing-title">NovaBotX™ — Pricing Plans</h2>
      <p className="pricing-subtitle">
        Flexible plans for teams, departments, and enterprises
      </p>

      {/* PRICING CARDS */}
      <div className="pricing-cards">
        {/* STARTER */}
        <div className="pricing-card">
          <h3>STARTER</h3>
          <p className="plan-desc">For small teams and pilots</p>
          <div className="price">$29<span>/month</span></div>
          <p className="annual">(or $299 billed annually)</p>

          <ul>
            <li>1 tenant</li>
            <li>Up to 5 users</li>
            <li>50 MB document storage</li>
            <li>PDFs, images, text uploads</li>
            <li>Up to 5 website links</li>
            <li>Vision-enabled understanding</li>
            <li>Web & link crawling</li>
            <li>Smart question suggestions</li>
            <li>Source-aware answers</li>
            <li>Email-based user management</li>
            <li>2FA authentication</li>
            <li>Standard email support</li>
          </ul>

          <p className="ideal">Ideal for:</p>
          <p className="ideal-text">Small teams • POCs • Startups</p>

          <Link to="/register" className="btn primary">
            Get Started
          </Link>
        </div>

        {/* BUSINESS */}
        <div className="pricing-card highlight">
          <h3>BUSINESS</h3>
          <p className="plan-desc">For growing teams and departments</p>
          <div className="price">$99<span>/month</span></div>
          <p className="annual">(or $999 billed annually)</p>

          <ul>
            <li>Up to 25 users</li>
            <li>250 MB document storage</li>
            <li>Unlimited document uploads</li>
            <li>Up to 50 website links</li>
            <li>Faster crawling & indexing</li>
            <li>Role-based access control</li>
            <li>Custom tenant branding</li>
            <li>Priority email support</li>
            <li>Admin dashboard & analytics</li>
            <li>Department-level deployment</li>
          </ul>

          <p className="ideal">Ideal for:</p>
          <p className="ideal-text">HR • Compliance • IT • Finance</p>

          <Link to="/register" className="btn primary">
            Start Free Trial
          </Link>
        </div>

        {/* ENTERPRISE */}
        <div className="pricing-card">
          <h3>ENTERPRISE</h3>
          <p className="plan-desc">For mission-critical use</p>
          <div className="price">Custom</div>

          <ul>
            <li>Unlimited users</li>
            <li>Custom storage limits</li>
            <li>Unlimited website crawling</li>
            <li>Advanced RBAC</li>
            <li>Tenant-level security policies</li>
            <li>SSO (SAML / OAuth)</li>
            <li>Audit logs & compliance</li>
            <li>API access & integrations</li>
            <li>Dedicated infrastructure option</li>
            <li>SLA-backed uptime</li>
            <li>Dedicated onboarding</li>
          </ul>

          <p className="ideal">Ideal for:</p>
          <p className="ideal-text">Large & regulated enterprises</p>

          <button className="btn primary">Contact Sales</button>
        </div>
      </div>

      {/* FEATURE TABLE */}
      <div className="pricing-table">
        <h3>Feature Comparison</h3>
        <table>
          <thead>
            <tr>
              <th>Feature</th>
              <th>Starter</th>
              <th>Business</th>
              <th>Enterprise</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Users</td><td>Up to 5</td><td>Up to 25</td><td>Unlimited</td></tr>
            <tr><td>Storage</td><td>50 MB</td><td>250 MB</td><td>Custom</td></tr>
            <tr><td>Vision AI</td><td><FiCheck className="icon-check" /></td><td><FiCheck className="icon-check" /></td><td><FiCheck className="icon-check" /></td></tr>
            <tr><td>Website Crawling</td><td>5</td><td>50</td><td>Unlimited</td></tr>
            <tr><td>RBAC</td><td>  <FiX className="icon-cross" /></td><td><FiCheck className="icon-check" /></td><td><FiCheck className="icon-check" /></td></tr>
            <tr><td>Custom Branding</td><td>  <FiX className="icon-cross" /></td><td><FiCheck className="icon-check" /></td><td><FiCheck className="icon-check" /></td></tr>
            <tr><td>SSO</td><td>  <FiX className="icon-cross" /></td><td>  <FiX className="icon-cross" /></td><td><FiCheck className="icon-check" /></td></tr>
            <tr><td>Audit Logs</td><td>  <FiX className="icon-cross" /></td><td>  <FiX className="icon-cross" /></td><td><FiCheck className="icon-check" /></td></tr>
          </tbody>
        </table>
      </div>

      {/* BOTTOM CTA */}
      <div className="pricing-cta">
        <h3>Not sure which plan is right for you?</h3>
        <p>Talk to our team to find the best plan for your organization.</p>
        <div className="cta-buttons">
          <a className="btn primary" href="#contact-form">Request a Demo</a>
          <a className="btn outline" href="#contact-form">Contact Sales</a>
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;
